import type { OrganizationQuery } from '@innovamat/glow-api-client';

type Organization = OrganizationQuery['organization'];

function isRosteringEnabled(organization: Organization): boolean {
  return organization?.source?.name === 'ROSTER_STREAM';
}

function isJourneysEnabled(organization: Organization): boolean {
  return organization?.permissions?.includes('mathJourneys') ?? false;
}

function isPlatformEnabled(organization: Organization): boolean {
  return !!organization?.permissions?.includes('app');
}

function isOrgAnonymized(organization: Organization): boolean {
  return organization?.anonymized ?? false;
}

export {
  isJourneysEnabled,
  isOrgAnonymized,
  isPlatformEnabled,
  isRosteringEnabled
};

  export type { Organization };
